<template>
  <PageTemplate>
    <v-container class="pt-10 pb-12">
      <Title class="text-center">Contato para Imprensa</Title>

      <v-row justify="center" class="mt-8 mt-md-10">
        <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
          <div
            class="
              grey--text
              text--darken-3 text-h6 text-md-h5
              font-weight-bold
            "
          >
            Assessoria de Comunicação
          </div>
          <div class="grey--text text--darken-2 text-body-1 text-md-h6 mt-4">
            Nara Vendrame
          </div>
          <div class="grey--text text--darken-2 text-body-1 text-md-h6 mt-2">
            BW Comunicação
          </div>
          <a
            v-ripple
            class="
              primary--text
              font-weight-medium
              text-none text-decoration-none
              d-inline-flex
              align-center
              mt-4
              text-h6 text-md-h5
            "
            :href="phoneLink"
            target="_blank"
          >
            <v-icon class="primary--text mr-2" size="22"
              >fab fa-whatsapp</v-icon
            >
            {{ phoneDisplay }}
          </a>
          <br />
          <v-btn
            color="primary"
            to="/imprensa/boletim-medico"
            depressed
            tile
            class="
              text-body-1
              font-weight-bold
              text-none
              mt-8
              py-3
              px-7 px-md-10
            "
          >
            Boletim Médico
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../templates/Page.vue";
import Title from "../widgets/Title.vue";
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

const PHONE = "(66) 9 9606-1416";

export default {
  components: {
    PageTemplate,
    Title,
  },
  data: () => ({
    phoneDisplay: PHONE,
    phoneLink: getWhatsappLinkFromPhone(PHONE),
  }),
};
</script>
